import React, { useState } from "react";
import { Button, Form, Input, Select, Space, Upload, Image } from 'antd';
import { MinusCircleOutlined, PlusOutlined, UploadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { menuItems } from "../../utils/constants";
import sterilizationBgImg from "../../assets/Images/sterilizationBgImg.jpeg"
import sterilizationHeadingImg from "../../assets/Images/sterilizationHeadingImg.jpeg"
import sterilizationStepsHeadingImg from "../../assets/Images/sterilizationStepsHeadingImg.jpeg"
import sterilizationTextImg from "../../assets/Images/sterilizationTextImg.jpeg"
import sterilizationDescriptionImg from "../../assets/Images/sterilizationDescriptionImg.jpeg"
import sterilizationBottomDescriptionImg from "../../assets/Images/sterilizationBottomDescriptionImg.jpeg"
import sterilizationImg from "../../assets/Images/sterilizationImg.jpeg"
import sterilizationTauclaveImg from "../../assets/Images/sterilizationTauclaveImg.jpeg"
import sterilizationStepsImg from "../../assets/Images/sterilizationStepsImg.jpeg"
import { assignLanguage, imageSizeFromBase64, getBase64, errorMessage } from "../../utils/helpers";
import { useSelector } from "react-redux";
import { MdOutlineRemoveCircle, MdOutlineAddCircle } from "react-icons/md";
const { Option } = Select
const ContentFormSterilization = ({ path, setPath }) => {
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = assignLanguage(language?.language)
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [form] = Form.useForm()
    const [showForm, setShowForm] = useState(true)
    const [fileDimensions] = useState({
        bgImg: { height: 350, width: 1920 },
        sterilizationImg: { height: 400, width: 1170 },
        sterilizationBottomImg: { height: 346, width: 534 },
    });
    const handleChange = (value) => {
        setPath(value);
        console.log('value', value)
    };
    const onFinish = async (values) => {
        let formData = new FormData()
        console.log('formData', values)
    }
    const normFile = (e, fieldName) => {
        if (e?.fileList?.length) {
            getBase64(e.file, async (url) => {
                const imageSize = await imageSizeFromBase64(url);
                const { height, width } = imageSize;

                const { height: reqHeight, width: reqWidth } = fileDimensions[fieldName] || {};

                if (height !== reqHeight || width !== reqWidth) {
                    form.setFieldsValue({ [fieldName]: [] });
                    errorMessage(
                        `The image for ${fieldName} must be ${reqHeight}px in height and ${reqWidth}px in width.`
                    );
                    return [];
                }
            });
        }

        const size = e?.file?.size / 1000;
        if (size > 1000) {
            errorMessage('File size should be less than 1MB.');
            return [];
        }
        if (e?.fileList?.length && !e?.file?.type.includes('image')) {
            errorMessage('You can only upload images.');
            return [];
        }

        if (Array.isArray(e)) {
            return e;
        }

        return e?.fileList;
    };
    // const normFile = (e) => {
    //     if (Array.isArray(e)) {
    //         return e;
    //     }
    //     return e?.fileList;
    // };
    return (
        <div className="main">
            <div className="content-form">
                <div className="content-form-heading-div">
                    <h2 className="content-form-heading">
                        {selectedLanguage?.txt_content_form_sterilization}
                    </h2>
                    {showForm ? <button onClick={() => setShowForm(false)}>
                        <MdOutlineRemoveCircle className="content-form-icon" />Remove
                    </button>
                        :
                        <button onClick={() => setShowForm(true)}>
                            <MdOutlineAddCircle className="content-form-icon" />Add
                        </button>}
                </div>
                <Form
                    initialValues={{ screen: path }}
                    form={form}
                    onFinish={onFinish}
                    layout='vertical'
                    requiredMark={true}
                >
                    <div>
                        <Form.Item
                            name='screen'
                            label={selectedLanguage?.txt_select_screen}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Select
                                showArrow
                                showSearch
                                allowClear
                                placeholder={selectedLanguage?.txt_select_screen}
                                optionFilterProp='children'
                                filterOption={true}
                                onChange={handleChange}
                            >
                                {menuItems.slice(0, -1).map((item, index) => (
                                    <Option key={index} value={item.menuName}>
                                        {isELSelect ? item?.menuName : (isAlSelect ? item?.menuALName : item?.menuGLName)}s
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    {showForm ? <div>
                        <div className="content_sections_div">
                            <h2>{selectedLanguage?.txt_sterilization_background_section}</h2>
                            <div className="content-form-doctor-section">
                                <Form.Item
                                    className="content_inputs"
                                    name='heading'
                                    label={selectedLanguage?.txt_heading}
                                >
                                    <Input placeholder={selectedLanguage?.txt_heading} />
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={sterilizationHeadingImg}
                                />
                                <Form.Item
                                    className="content_inputs"
                                    name='description'
                                    label={selectedLanguage?.txt_description}
                                >
                                    <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_description} />
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={sterilizationTextImg}
                                />
                                <Form.Item
                                    className="content-form-logo-div"
                                    label={selectedLanguage?.txt_sterilization_background_image}
                                    name='bgImg'
                                    valuePropName='fileList'
                                    getValueFromEvent={(e) => normFile(e, 'bgImg')}
                                    extra="Please upload an image with dimensions (Height: 350px, Width: 1920px)"
                                >
                                    <Upload
                                        maxCount={1}
                                        multiple={true}
                                        accept='image/*'
                                        name='bgImg'
                                        action='/upload.do'
                                        listType='text'
                                        beforeUpload={() => false}
                                    >
                                        <Button icon={<UploadOutlined />}>{selectedLanguage?.txt_upload}</Button>
                                    </Upload>
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={sterilizationBgImg}
                                />
                            </div>
                        </div>
                        <div className="content_sections_div">
                            <h2>{selectedLanguage?.txt_Sterilization_heading}</h2>
                            <Form.Item
                                className="content_inputs"
                                name='sterilizationDescription'
                                label={selectedLanguage?.txt_description}
                            >
                                <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_description} />
                            </Form.Item>
                            <Image
                                width={150}
                                src={sterilizationDescriptionImg}
                            />
                            <Form.Item
                                className="content_inputs"
                                name='sterilizationStepsHeading'
                                label={selectedLanguage?.txt_sterilization_step_heading}
                            >
                                <Input placeholder={selectedLanguage?.txt_sterilization_step_heading} />
                            </Form.Item>
                            <Image
                                width={150}
                                src={sterilizationStepsHeadingImg}
                            />
                            <Form.List name='followList' initialValue={[{ list: null }]}>
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.map(({ key, name, ...restField }) => (
                                            <Space
                                                className="formList-main"
                                                key={key}
                                                style={{
                                                    display: 'flex',
                                                    marginBottom: 8,
                                                    flexWrap: 'wrap'
                                                }}
                                            >
                                                <Form.Item
                                                    className="content_inputs"
                                                    {...restField}
                                                    name={[name, 'list']}
                                                    label={selectedLanguage?.txt_follow_step}
                                                >
                                                    <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_follow_step} />
                                                </Form.Item>
                                                <Image
                                                    width={150}
                                                    src={sterilizationStepsImg}
                                                />
                                                {fields.length > 1 ?
                                                    <span style={name ? { marginTop: -25, position: 'absolute' } : {}}>
                                                        <MinusCircleOutlined onClick={() => remove(name)} />
                                                    </span>
                                                    :
                                                    null
                                                }
                                            </Space>
                                        ))}
                                        <Form.Item>
                                            <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                                                {selectedLanguage?.add_button_txt}
                                            </Button>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </div>
                        <div className="content_sections_div">
                            <Form.Item
                                className="content-form-logo-div"
                                label={selectedLanguage?.txt_sterilization_image}
                                name='sterilizationImg'
                                valuePropName='fileList'
                                getValueFromEvent={(e) => normFile(e, 'sterilizationImg')}
                                extra="Please upload an image with dimensions (Height: 400px, Width: 1170px)"
                            >
                                <Upload
                                    maxCount={1}
                                    multiple={true}
                                    accept='image/*'
                                    name='sterilizationImg'
                                    action='/upload.do'
                                    listType='text'
                                    beforeUpload={() => false}
                                >
                                    <Button className="logo-upload-btn" icon={<UploadOutlined />}>{selectedLanguage?.upload_Button}</Button>
                                </Upload>
                            </Form.Item>
                            <Image
                                width={150}
                                src={sterilizationImg}
                            />
                        </div>
                        <div className="content_sections_div">
                            <h2>{selectedLanguage?.txt_sterilization_bottom_section}</h2>
                            <Form.List name='sterilizationBottomDescription' initialValue={[{ description: null }]}>
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.map(({ key, name, ...restField }) => (
                                            <Space
                                                className="formList-main"
                                                key={key}
                                                style={{
                                                    display: 'flex',
                                                    marginBottom: 8,
                                                    flexWrap: 'wrap'
                                                }}
                                            >
                                                <Form.Item
                                                    className="content_inputs"
                                                    {...restField}
                                                    name={[name, 'description']}
                                                    label={selectedLanguage?.txt_description}
                                                >
                                                    <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_description} />
                                                </Form.Item>
                                                <Image
                                                    width={150}
                                                    src={sterilizationBottomDescriptionImg}
                                                />
                                                {fields.length > 1 ?
                                                    <span style={name ? { marginTop: -25, position: 'absolute' } : {}}>
                                                        <MinusCircleOutlined onClick={() => remove(name)} />
                                                    </span>
                                                    :
                                                    null
                                                }
                                            </Space>
                                        ))}
                                        <Form.Item>
                                            <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                                                {selectedLanguage?.add_button_txt}
                                            </Button>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                            <Form.Item
                                className="content-form-logo-div"
                                label={selectedLanguage?.txt_steriliation_bottom_image}
                                name='sterilizationBottomImg'
                                valuePropName='fileList'
                                getValueFromEvent={(e) => normFile(e, 'sterilizationBottomImg')}
                                extra="Please upload an image with dimensions (Height: 346px, Width: 534px)"
                            >
                                <Upload
                                    maxCount={1}
                                    multiple={true}
                                    accept='image/*'
                                    name='sterilizationBottomImg'
                                    action='/upload.do'
                                    listType='text'
                                    beforeUpload={() => false}
                                >
                                    <Button className="logo-upload-btn" icon={<UploadOutlined />}>{selectedLanguage?.upload_Button}</Button>
                                </Upload>
                            </Form.Item>
                            <Image
                                width={150}
                                src={sterilizationTauclaveImg}
                            />
                        </div>
                        <Form.Item
                            className="content_inputs"
                            name='remark'
                            label={selectedLanguage?.txt_remark}
                            rules={[
                                {
                                    required: true,
                                    message: '',
                                }
                            ]}
                            required
                        >
                            <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_remark} />
                        </Form.Item>
                        <Form.Item >
                            <Button
                                htmlType='submit'
                                style={{ borderRadius: 4, width: '100%', marginTop: '25px' }}
                                type='primary'
                            // loading={loading}
                            >
                                {selectedLanguage?.submit_button}
                            </Button>
                        </Form.Item>
                    </div> : null}
                </Form>
            </div>
        </div>
    )
}

export default ContentFormSterilization